import { useState } from 'react';
import CountUp from 'react-countup';
import { Button, Card, CardBody } from 'reactstrap';
import { H6, ToolTip } from '../../../../AbstractElements';

const WalletWidget = ({ type, balance, hook }) => {
    const { toggleModal } = hook;
    const [tooltip, setTooltip] = useState(false);
    const toggle = () => setTooltip(!tooltip);

    // FIX: Convert to number to ensure "0.00" is treated as 0
    const numericBalance = Number(balance) || 0;
    const isBalanceZero = numericBalance <= 0;

    const data = {
        savings: {
            id: 'savings', title: 'Savings Wallet', color: 'secondary', backColor: 'white',
            tip: 'All deposits come to this wallet. All withdrawals/debits are made from here.'
        },
        terms: {
            id: 'terms', title: 'Term Savings Wallet', color: 'warning', backColor: 'white',
            tip: 'This wallet holds money put away and fixed for a specific duration.'
        },
        interest: {
            id: 'interest', title: 'Interests Wallet', color: 'primary', backColor: 'white',
            tip: 'This wallet holds earned interests. You can transfer these to Savings.'
        }
    };

    const activeConfig = data[type] || { id: 'unknown', title: 'Wallet', backColor: 'white' };

    const buttonStyle = {
        fontSize: '11px', 
        textTransform: 'uppercase', 
        letterSpacing: '0.5px',
        borderRadius: '8px', 
        padding: '8px 12px', 
        fontWeight: '700',
        display: 'flex', 
        alignItems: 'center', 
        whiteSpace: 'nowrap',
        // Visual feedback for disabled state
        opacity: isBalanceZero ? 0.5 : 1,
        cursor: isBalanceZero ? 'not-allowed' : 'pointer',
        pointerEvents: isBalanceZero ? 'none' : 'auto' 
    };

    return (
        <Card className='widget-1 p-0' style={{ background: activeConfig.backColor, borderRadius: 15, border: '1px solid #f0f2f5' }}>
            <CardBody className='p-20'>
                <div className='p-2'>
                    <div className='d-flex align-items-center justify-content-between'>
                        <div className='d-flex align-items-center'>
                            <H6 attrH6={{ style: { fontSize: '17px', color: '#2c3e50', margin: 0, fontWeight: '700' } }}>
                                {activeConfig.title}
                            </H6>
                            <i className="ms-2 icon-info-alt font-dark" id={activeConfig.id} style={{ cursor: 'pointer', color: '#a0aec0' }}></i>
                            <ToolTip attrToolTip={{ placement: 'top', isOpen: tooltip, target: activeConfig.id, toggle: toggle }}>
                                {activeConfig.tip}
                            </ToolTip>
                        </div>
                    </div>

                    <div style={{ overflow: 'hidden' }}>
                        <CountUp end={numericBalance} decimals={2} prefix='₦' separator="," duration={1.5}
                            style={{ display: 'block', margin: '12px 0', fontSize: 'min(30px, 5.5vw)', fontWeight: '800', color: '#1a202c' }}
                        />
                    </div>

                    {type === 'savings' && (
                        <div className='d-flex gap-2 mb-2'>
                            <Button 
                                className='shadow-sm' 
                                // Native disabled attribute
                                disabled={isBalanceZero}
                                style={{ 
                                    ...buttonStyle, 
                                    backgroundColor: isBalanceZero ? '#cccccc' : '#d63031', 
                                    borderColor: isBalanceZero ? '#cccccc' : '#d63031', 
                                    color: '#fff' 
                                }} 
                                onClick={() => !isBalanceZero && toggleModal('debit', type, balance)}
                            >
                                {isBalanceZero ? 'Empty Wallet' : 'Debit Wallet'}
                            </Button>
                        </div>
                    )}

                    <H6 attrH6={{ 
                        style: { visibility: type === 'terms' ? 'visible' : 'hidden', color: '#27ae60', fontWeight: '600' },
                        className: 'm-t-5 font-outfit font12' 
                    }}>
                        +3.0% Monthly ROI
                    </H6>
                </div>
            </CardBody>
        </Card>
    );
};

export default WalletWidget;